export default __webpack_public_path__ + "static/media/BG.d8f3e7cb.jpg";